import script from "./SelectPDF.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectPDF.vue?vue&type=script&setup=true&lang=js"

import "./SelectPDF.vue?vue&type=style&index=0&id=48a2ef85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a2ef85"]])

export default __exports__